export const GLOBAL_THEME: any = {
	Colors: {
		black: '#000000',
		white: '#ffffff',

		darkgrey: '#333333',
		darkGrey2: '#4d4d4d',

		lightGrey: '#f2f2f2',

		success: '#1F8000',
		error: '#892C21',

		textRed: '#D22B2B',
		textGreen: '#008000',

		cellRed: '#ee9090',
		cellGreen: '#90ee90',
		cellOrange: '#ffd580',
		cellYellow: '#ffffa3',
		cellGrey: '#A9A9A9',
		lightgreen: 'lightgreen',
		lightcoral: 'lightcoral'
	},
	FontFamily: {
		FONT1_REGULAR: 'Muli',
		FONT1_ITALIC: 'Calibri-LightItalic',
		FONT2_REGULAR: 'OcrA'
	},
	FontSize: {
		Overline: 10,
		Caption: 12,
		Body: 14,
		Subtitle: 16,
		H6: 20,
		H5: 24,
		H4: 34,
		H3: 48,
		H2: 60,
		H1: 95
	}
};
